export const ResidentAlreadyAssignedToTheAddress = 'ResidentAlreadyAssignedToTheAddress';
export const InvalidVerificationCode = 'InvalidVerificationCode';
export const VerificationCodeHasExpired = 'VerifictionCodeHasExpired';
export const ResidentDeletionRequested = 'ResidentDeletionRequested';
export const InvalidRefreshToken = 'InvalidRefreshToken';
export const UserNotFound = 'UserNotFound';
